import axios from "axios";
console.log("API URL LOADED:", process.env.REACT_APP_API_URL);

export const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});
